import { COMMAND_IDS } from '@punica/editor';
import { parseKeyChord } from './parse.js';

/**
 * Substrate default keymap — the VSCode-style shortcuts that belong to the
 * shell itself rather than to any single extension. These bind only to CORE
 * command ids (layout slot toggles), so the substrate stays product-neutral;
 * view-specific bindings (AI assistant, terminal) live in their owning
 * extension manifests.
 *
 * Registered once at shell start. Individual extensions may still declare
 * their own bindings via `integrations.keybindings`.
 */
export function registerDefaultKeymap(): void {
  const manager = (globalThis as any).punica?.shell?.KeyboardShortcuts
    ?.manager as
    | {
        registerShortcut(s: {
          command: string;
          keys: unknown[];
          when?: string;
        }): void;
      }
    | undefined;
  if (!manager) return;

  const bind = (chord: string, command: string, when?: string): void => {
    manager.registerShortcut({ command, keys: [parseKeyChord(chord)], when });
  };

  // Cmd/Ctrl+J — toggle the bottom panel.
  bind('mod+j', COMMAND_IDS.SHELL.TOGGLE_PANEL);
  // Cmd/Ctrl+B — toggle the primary side bar.
  bind('mod+b', COMMAND_IDS.SHELL.TOGGLE_PRIMARY_SIDEBAR);
  // Cmd/Ctrl+L — toggle the secondary (right) side bar. Generic region toggle
  // like the two above; today the AI assistant is the view living there.
  bind('mod+l', COMMAND_IDS.SHELL.TOGGLE_SECONDARY_SIDEBAR);
}
